<template>
  <div class="wrapper" v-if="weAreHiring">
    <Header @hamburger-click="focus = !focus" />

    <Hero
      photo="level_up-WEB_2.png"
      :class="{ focus: true, 'focus--hide': focus }"
    />
    <Text
      heading="Wat doen wij?"
      footer="We’ve come a long way..."
      :white="true"
      id="wat-doen-wij"
      :class="{ focus: true, 'focus--hide': focus }"
    >
      <p>
        Wij maken al websites sinds 1996. Van statische HTML pagina’s van toen
        naar CMS gestuurde responsive websites vandaag, op basis van ons eigen
        custom MVC framework, VueJS, Laravel, …
      </p>
    </Text>

    <Photo src="photo-01.png" :class="{ focus: true, 'focus--hide': focus }" />

    <Text
      heading="Wat doen wij?"
      footer="Géén Squarespace, Drupal of Wordpress"
      :class="{ focus: true, 'focus--hide': focus }"
    >
      <p>
        Door het gebruik van ons eigen PHP framework en Laravel stemmen we
        webprojecten volledig op maat af op de wensen van onze klanten. Vandaar
        dat klanten zoals o.a.
        <a href="https://www.democrazy.be/" target="_blank" title="Democrazy"
          >Democrazy</a
        >,
        <a
          href="https://www.musicmaniarecords.be/"
          target="_blank"
          title="Music Mania Records"
          >Music Mania Records</a
        >,
        <a
          href="https://pro.morleyforkids.be/"
          target="_blank"
          title="Morley Pro Application"
          >Morley</a
        >,
        <a
          href="https://mijn.veroniquesneyaert.be/"
          target="_blank"
          title="Veronique"
          >Veronique</a
        >,
        <a
          href="https://www.depuydthaarden.be/nl/"
          title="De Puydt Haarden"
          target="_blank"
          >De Puydt</a
        >,

        <a
          href="https://www.charlottepringels.com/"
          target="_blank"
          title="Charlotte Pringels"
          >Charlotte Pringels</a
        >
        en
        <a
          href="https://www.verellenfurniture.be/"
          target="_blank"
          title="Verellen furniture"
          >Verellen Furniture</a
        >
        bewust voor ons kiezen voor de ontwikkeling van hun webprojecten.
      </p>

      <p>
        Ontdek
        <a
          href="https://www.tnt.be/cases/"
          target="_blank"
          rel="noopener noreferer"
        >
          onze cases
        </a>
        en
        <a
          href="https://www.tnt.be/the-wall/"
          target="_blank"
          rel="noopener noreferer"
        >
          onze wall</a
        >!
      </p>
    </Text>

    <Photo
      src="de-puydt.png"
      :fixed="true"
      :class="{ focus: true, 'focus--hide': focus }"
    />
    <Photo
      src="hero-temp.jpg"
      :fixed="true"
      :class="{ focus: true, 'focus--hide': focus }"
    />

    <Text
      heading="Wat doen wij?"
      footer="We do it all!"
      :white="true"
      :class="{ focus: true, 'focus--hide': focus }"
    >
      <p>
        E-commerce, online stock systemen, booking applicaties, API
        ontwikkeling, presentatie websites, e-mailings, ... Met oog voor detail
        en passie voor het web.
      </p>
      <p>
        Onze aanpak is eigenwijs: wat we beter kunnen, doen we zelf. We bijten
        ons vast tot we het verschil maken.
      </p>
    </Text>

    <Photo
      src="pringels.png"
      :fixed="true"
      :class="{ focus: true, 'focus--hide': focus }"
    />
    <Photo
      src="photo-15.png"
      :fixed="true"
      :class="{ focus: true, 'focus--hide': focus }"
    />

    <Text
      heading="Wie zoeken wij?"
      footer="Iemand met passie voor het web en de techniek erachter"
      id="wie-zoeken-wij"
      :class="{ focus: true, 'focus--hide': focus }"
    >
      <Column>
        <div class="column">
          <Title headingType="h3">Junior functie</Title>
          <ul>
            <li>Kennis van HTML/CSS/JavaScript</li>
            <li>
              Basiskennis van PHP, gemotiveerd om deze kennis uit te breiden.
            </li>
            <li>Werkervaring is geen vereiste</li>
            <li>Je woont in de regio</li>
          </ul>
        </div>
        <div class="column">
          <Title headingType="h3">Senior functie</Title>
          <ul>
            <li>
              Uitgebreide kennis van responsive HTML5/CSS3/SASS, PHP in een MVC
              framework, MySQL, Git, Vagrant.
            </li>
            <li>Kennis Javascript, React/Vue en Laravel is een plus</li>
            <li>Je woont in de regio</li>
          </ul>
        </div>
      </Column>
    </Text>

    <Photo
      src="sfeerfoto1.jpg"
      :class="{ focus: true, 'focus--hide': focus }"
    />
    <!-- <Photo src="mm2.png" :class="{ focus: true, 'focus--hide': focus }" />s -->

    <Photo
      src="photo-12.jpg"
      :fixed="true"
      :class="{ focus: true, 'focus--hide': focus }"
    />
    <img
      src="./assets/img/photo-04-1.png"
      style="display: block; width: 100%"
      :class="{ focus: true, 'focus--hide': focus }"
    />

    <Text
      heading="Wie bieden wij?"
      footer="Kwaliteit boven buzzwords, al meer dan 40 jaar lang"
      id="wat-bieden-wij"
      :white="true"
      :class="{ focus: true, 'focus--hide': focus }"
    >
      <Column>
        <div class="column">
          <ul>
            <li>Uitdagende en vaste job in een gemotiveerd team.</li>
            <li>Gevarieerde opdrachten in front- en backend</li>
            <li>Aangename werkomgeving</li>
            <li>
              Nauwe samenwerking met onze webdesigner en collega web developer.
            </li>
          </ul>
        </div>
        <div class="column">
          <ul>
            <li>Ruimte om jouw kennis & skills verder te ontwikkelen</li>
            <li>Stabiel bedrijf met een uitgebreide technische kennis</li>
            <li>Concurrentiële verloning</li>
            <li>Vlotte bereikbaarheid via het openbaar vervoer of auto</li>
          </ul>
        </div>
      </Column>
    </Text>

    <Photo
      src="sfeerfoto2.jpg"
      :class="{ focus: true, 'focus--hide': focus }"
    />

    <Text
      heading="Interesse?"
      footer="Aarzel niet om te solliciteren!"
      id="interesse"
      :class="{ focus: true, 'focus--hide': focus }"
    >
      <p>
        Stuur je sollicitatiebrief met volledige C.V. naar ons kantoor t.a.v.
        Jana Tallieu:
      </p>
      <p>
        <a
          href="mailto:wewantyou@tnt.be"
          title="Stuur je sollicitatiebrief naar wewantyou@tnt.be"
          >wewantyou@tnt.be</a
        >
      </p>
      <p>PS: Je kandidatuur wordt discreet behandeld.</p>
    </Text>
    <Footer :class="{ focus: true, 'focus--hide': focus }" />
  </div>
  <NotHiring v-if="!weAreHiring"/>
</template>

<script>
import Header from "@/components/Header.vue";
import Hero from "@/components/Hero.vue";
import Text from "@/components/Text.vue";
import Photo from "@/components/Photo.vue";
import Column from "@/components/Column.vue";
import Footer from "@/components/Footer.vue";
import NotHiring from "@/components/NotHiring.vue";

export default {
  name: "WeWantYou",
  components: {
    Header,
    Hero,
    Text,
    Photo,
    Column,
    Footer,
    NotHiring,
  },
  data() {
    return {
      focus: false,
      weAreHiring: false,
    };
  },
};
</script>
<style lang="scss">
@import "./assets/mixins.scss";

.column {
  margin: 3em 0;
  @include mq(lg) {
    margin: unset;
  }
}

#app {
  // scroll-snap-type: y proximity;
  overflow-y: scroll;
  height: 100%;
  height: 100vh;
}

.focus {
  opacity: 1;
  transition: opacity 300ms ease-in-out, filter 300ms ease-in-out;

  &--hide {
    opacity: 0.2;
    filter: blur(5px);
    @include mq(lg) {
      opacity: unset;
      filter: unset;
    }
  }
}

</style>
